var _path, _path2, _rect, _path3, _path4, _path5, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4, _rect5, _circle5, _rect6, _circle6, _rect7, _circle7, _rect8, _circle8, _rect9, _circle9, _rect0, _circle0, _rect1;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoadingmanagerintentions = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 280,
    viewBox: "0 0 506 280",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.273 140C280.273 115.301 273.738 91.0408 261.332 69.6828C248.927 48.3249 231.092 30.6291 209.637 18.3916C188.182 6.15404 163.872 -0.189667 139.173 0.00431785C114.474 0.198303 90.2666 6.92308 69.0068 19.4961C47.747 32.0691 30.1918 50.0429 18.1231 71.593C6.05448 93.1432 -0.0981041 117.503 0.289854 142.199C0.677812 166.895 7.5925 191.05 20.3321 212.21C33.0717 233.37 51.1828 250.784 72.827 262.683L93.0607 225.878C77.9097 217.549 65.232 205.359 56.3143 190.547C47.3965 175.735 42.5562 158.827 42.2847 141.539C42.0131 124.252 46.3199 107.2 54.768 92.1151C63.216 77.03 75.5046 64.4484 90.3865 55.6473C105.268 46.8462 122.214 42.1388 139.503 42.003C156.792 41.8672 173.809 46.3078 188.828 54.8741C203.846 63.4404 216.331 75.8274 225.014 90.778C233.698 105.729 238.273 122.71 238.273 140H280.273Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.273 140C280.273 164.327 273.934 188.233 261.881 209.364C249.828 230.495 232.477 248.121 211.538 260.504C190.599 272.887 166.795 279.601 142.472 279.983C118.148 280.365 94.1446 274.402 72.8271 262.683L93.0607 225.878C107.983 234.082 124.785 238.255 141.812 237.988C158.838 237.72 175.501 233.021 190.159 224.353C204.816 215.684 216.962 203.347 225.398 188.555C233.835 173.763 238.273 157.029 238.273 140H280.273Z",
    fill: "#757575"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.4902,
    y: 108.804,
    width: 123.87,
    height: 63.6087,
    rx: 31.8043,
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341 265L335 259L329 265",
    stroke: "#BFC3CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.634 256.818V267H358.401V258.111H358.341L355.855 259.761V258.509L358.401 256.818H359.634ZM366.181 256.341L362.9 268.531H361.826L365.107 256.341H366.181ZM370.992 267.139C370.336 267.139 369.751 267.027 369.237 266.801C368.727 266.576 368.321 266.263 368.019 265.862C367.721 265.457 367.559 264.988 367.532 264.455H368.785C368.811 264.783 368.924 265.066 369.123 265.305C369.322 265.54 369.582 265.722 369.904 265.852C370.225 265.981 370.581 266.045 370.972 266.045C371.41 266.045 371.798 265.969 372.136 265.817C372.474 265.664 372.739 265.452 372.931 265.18C373.124 264.909 373.22 264.594 373.22 264.236C373.22 263.861 373.127 263.531 372.941 263.246C372.756 262.958 372.484 262.733 372.126 262.57C371.768 262.408 371.33 262.327 370.813 262.327H369.998V261.233H370.813C371.218 261.233 371.572 261.16 371.877 261.014C372.186 260.868 372.426 260.663 372.598 260.398C372.774 260.133 372.862 259.821 372.862 259.463C372.862 259.118 372.785 258.818 372.633 258.563C372.481 258.308 372.265 258.109 371.987 257.967C371.712 257.824 371.387 257.753 371.012 257.753C370.661 257.753 370.329 257.817 370.018 257.947C369.71 258.073 369.458 258.257 369.262 258.499C369.067 258.737 368.961 259.026 368.944 259.364H367.751C367.771 258.83 367.932 258.363 368.233 257.962C368.535 257.557 368.929 257.242 369.416 257.017C369.907 256.792 370.445 256.679 371.032 256.679C371.662 256.679 372.202 256.807 372.653 257.062C373.104 257.314 373.45 257.647 373.692 258.061C373.934 258.475 374.055 258.923 374.055 259.403C374.055 259.977 373.904 260.466 373.602 260.87C373.304 261.274 372.898 261.554 372.384 261.71V261.79C373.027 261.896 373.53 262.169 373.891 262.61C374.252 263.048 374.433 263.589 374.433 264.236C374.433 264.789 374.282 265.286 373.98 265.727C373.682 266.165 373.274 266.509 372.757 266.761C372.24 267.013 371.652 267.139 370.992 267.139Z",
    fill: "#455CC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390 259L396 265L402 259",
    stroke: "#455CC7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 18,
    r: 4,
    fill: "#D81B60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 10,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 42,
    r: 4,
    fill: "#5E35B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 34,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 66,
    r: 4,
    fill: "#1E88E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 58,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 90,
    r: 4,
    fill: "#00ACC1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 82,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 114,
    r: 4,
    fill: "#43A047"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 106,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 138,
    r: 4,
    fill: "#C0CA33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 130,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 162,
    r: 4,
    fill: "#FFB300"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 154,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 186,
    r: 4,
    fill: "#F4511E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 178,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 210,
    r: 4,
    fill: "#6D4C41"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 202,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 234,
    r: 4,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 226,
    width: 163,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingmanagerintentions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loadingmanagerintentions.1ec69684.svg";
export { ForwardRef as ReactComponent };